// src/components/ProductPage/QuantitySelector.js
import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';

const QuantitySelector = ({ quantity, setQuantity, maxQuantity }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
      <Typography 
        variant="h6" 
        sx={{ 
          mr: 1,
          fontWeight: 'bold',
          color: '#333'
        }}
      >
        الكمية:
      </Typography>
      <Box sx={{ 
        mr: 1,
        display: 'flex', 
        alignItems: 'center',
        border: '2px solid #e0e0e0',
        borderRadius: 2,
        overflow: 'hidden'
      }}>
        <IconButton
          onClick={() => setQuantity(q => q + 1)}
          disabled={maxQuantity <= quantity}
          sx={{ 
            borderRadius: 0,
            px: 2,
            '&:hover': { bgcolor: '#f5f5f5' }
          }}
        >
          +
        </IconButton>
        <Typography sx={{ 
          px: 3, 
          py: 1, 
          fontWeight: 'bold',
          minWidth: 40,
          textAlign: 'center'
        }}>
          {quantity}
        </Typography>
        <IconButton 
          onClick={() => setQuantity(q => Math.max(1, q - 1))}
          sx={{ 
            borderRadius: 0,
            px: 2,
            '&:hover': { bgcolor: '#f5f5f5' }
          }}
        >
          -
        </IconButton>
      </Box>
    </Box>
  );
};

export default QuantitySelector;
